<template>
	<vx-card class="client-orders-table">
		<vs-tabs @setActiveTab="setActiveTab" v-if="tabs.length > 0">
			<vs-tab
				v-for="tab in tabs"
				:key="tab.title"
				:value="indexTab"
				:label="tab.title"
			>
				<div class="filter vx-row lg:flex-row flex-col-reverse flex">
					<div class="date vx-col xl:w-auto md:w-3/4 flex">
						<div class="vx-row flex-grow">
							<div
								class="vs-component vs-con-input-label vs-input vs-input-primary vx-col xl:w-auto sm:w-1/3 w-1/2 mt-3"
							>
								<div class="vs-con-input"></div>
								<vs-datepicker
									v-model="off"
									format="dd.MM.yyyy"
									:placeholder="$t('from')"
									name="date"
									class=""
								></vs-datepicker>
							</div>
							<div
								class="vs-component vs-con-input-label vs-input vs-input-primary vx-col xl:w-auto sm:w-1/3 w-1/2 mt-3"
							>
								<div class="vs-con-input"></div>
								<vs-datepicker
									v-model="to"
									format="dd.MM.yyyy"
									:placeholder="$t('to')"
									name="date"
								></vs-datepicker>
							</div>
							<div class="vx-col xl:w-auto sm:w-1/3 w-full mt-3">
								<vs-custom-button
									color="dark"
									type="border"
									@click="(off = ''), (to = ''),(search = '')"
									class="vs-custom-button w-full"
								>{{ $t('reset') }}</vs-custom-button>
							</div>
						</div>
					</div>
					<div class="search vx-col xl:w-auto md:w-3/4 flex">
						<div class="vx-row flex-grow sm:flex-row flex-col-reverse">
							<div
								:class="{ 'sm:w-2/3': userRole === 'manager' }"
								class="vx-col w-full xl:w-auto mt-3"
							>
								<vs-input
									v-model="search"
									icon="search"
									icon-after
									:placeholder="$t('searchByOrderName')"
									class="w-full"
								/>
							</div>
							<div v-if="userRole === 'manager'" class="vx-col w-full sm:w-1/3 xl:w-auto mt-3">
								<RouterLink :to="`/ticket/create/${clientId}`">
									<vs-button
										color="success"
										class="w-full pl-1 pr-1 xl:pl-5 xl:pr-5"
									>{{ $t('addOrder') }}</vs-button>
								</RouterLink>
							</div>
						</div>
					</div>
				</div>
				<div class="tab-text">
					<vs-table
						:sst="true"
						@change-page="setPageNumber"
						max-items="10" 
						pagination
						:currentPage="currentPage"
						:total="totalOrders"
						:data="currentPageList"
					>
						<template slot="thead">
							<vs-th v-for="fil in field" :class="{ 'author-header': fil.title === $t('author') }">
								{{ fil.title }}
							</vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr
								:key="indextr"
								v-for="(tr, indextr) in data"
								:class="{ 'deal-today': hasDealToday(tr) }"
							>
								<template v-for="fil in field">
									<vs-td v-if="fil.field === 'name'">
										<router-link :to="'/ticket/' + tr.id">
											{{ tr.name }}
										</router-link>
									</vs-td>

									<vs-td v-else-if="fil.field === 'client.full_name'">
										<router-link :to="`${pathToClient}/${ deepFind(tr, 'client.id')}`">
											{{ deepFind(tr, fil.field) }}
										</router-link>
									</vs-td>

									<vs-td v-else-if="fil.field === 'author.username'">
										<router-link
											v-if="tr[fil.field.split('.')[0]]"
											:to="`/${pathToAuthor}/${deepFind(tr, 'author.id')}`"
											class="flex justify-center text-center"
										>
											{{ deepFind(tr, fil.field) || '---' }}
										</router-link>
									</vs-td>

									<vs-td v-else-if="fil.field === 'chat_messages_count'">
											<span
												class="counter"
												:class="{ warn: tr.is_chat_unread }"
											>
												{{ tr.chat_messages_count }}
											</span>
									</vs-td>

									<vs-td v-else-if="fil.field === 'created' || fil.field === 'due_date'">
										<div style="width: 100px">
											{{ tr[fil.field] }}
										</div>
									</vs-td>

									<vs-td v-else-if="fil.field === 'status'">
										{{ $getStatus(tr.status) }}
									</vs-td>

									<vs-td v-else-if="fil.field === 'subject'">
										{{ $getDeep(tr.subject, subjects) }}
									</vs-td>

									<vs-td v-else-if="fil.field === 'work_type'">
										{{ $getDeep(tr.work_type, works) }}
									</vs-td>

									<vs-td v-else-if="fil.field === 'quality_level'">
										{{ $getDeep(tr.quality_level, levels) }}
									</vs-td>

									<vs-td v-else-if="fil.field === 'task'">
											<span
												class="task cursor-pointer"
												v-if="tr[fil.field]"
												@click="editTask(tr)"
											>{{ tr[fil.field].date_time | moment('DD.MM.YYYY') }}</span>
										<span
											class="task cursor-pointer"
											@click="selectedOrder = tr; addTaskPopup = true"
											v-else
										>+</span>

									</vs-td>
									<vs-td v-else-if="tr[fil.field]">
										{{ tr[fil.field] }}
									</vs-td>
									<vs-td v-else>
										...
									</vs-td>
								</template>
							</vs-tr>
						</template>
					</vs-table>
				</div>
			</vs-tab>
		</vs-tabs>
		<AddOrderTask
			:active.sync="addTaskPopup"
			:order="selectedOrder"
		/>
		<ViewOrderTask
			:active.sync="viewTaskPopup"
			:order="selectedOrder"
		/>
	</vx-card>
</template>

<script>
import AddOrderTask from "@/components/dialogs/AddOrderTask";
import ViewOrderTask from "@/components/dialogs/ViewOrderTask";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import clientOrdersHeaders from "@/assets/configs/clientOrdersHeaders";

export default {
	name: "ClientOrdersTable",
	mixins: [databaseManager, notifier],
	props: {
		clientId: {
			type: Number,
			default: -1,
		}
	},
	components: {
		AddOrderTask,
		ViewOrderTask,
	},
	data() {
		return {
			currentPage: 1,
			totalOrders: 1,

			idOrder: 0,
			date: "",
			off: "",
			indexTab: 0,
			to: "",
			about: "",
			search: "",
			addTaskPopup: false,
			viewTaskPopup: false,
			selectedOrder: null,
			tabs: [],
			// orders: {
			// 	active: [],
			// 	history: [],
			// },
			active: [],
			history: [],
			
			subjects: [],
			works: [],
			levels: [],
			tasks: [],
			field: [],
		};
	},
	watch: {
		off() {
			this.filter(true);
		},
		to() {
			this.filter(true);
		},
		search() {
			this.filter(true);
		}
	},
	computed: {
		currentPageList() {
			let item = this.tabs[this.indexTab];
			return item.key === 'active' 
				? this.active 
				: this.history;
		},
		userRole() {
			return this.$store.state.auth.role;
		},
		pathToAuthor() {
			if(this.$store.state.auth.role === "admin") {
				return 'author';
			} else if(this.$store.state.auth.role === "manager") {
				return 'authorM';
			}
		},
		pathToClient() {
			if(this.$store.state.auth.role === "admin") {
				return 'client';
			} else if(this.$store.state.auth.role === "manager") {
				return 'clientM';
			}
		}
	},
	methods: {
		async setActiveTab(data) {
			const prev = this.indexTab;
			this.indexTab = data;
			if (prev === 0 && this.indexTab < 1) return;
			this.currentPage = 1;
			await this.filter()
		},
		async setPageNumber(data) {
			this.currentPage = data;
			await this.filter()
		},
		hasDealToday(tr) {
			if(!tr || !tr.task) return false;

			const [date] = tr.task.date_time.split(" ");
			const [year, month, day] = date.split("-");

			const current = new Date();
			const cYear = current.getFullYear();
			let cMonth = current.getMonth() + 1;
			cMonth = cMonth >= 10 ? cMonth : '0' + cMonth;
			let cDay = current.getDate();
			cDay = cDay >= 10 ? cDay : '0' + cDay;

			return +year === +cYear
				&& +month === +cMonth
				&& +day === +cDay;
		},
		async editTask(order) {
			if (order === null || order === undefined) return;

			this.selectedOrder = order;
			this.viewTaskPopup = true;
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getTickets(tab, options) {
      this.active = []
      this.history = []
			const ticketsList = this.currentPageList;
			const offset = options.offset;
			try {
				const res = await this.dbGetClientTickets(this.clientId, options);
				this.totalOrders = res.count;

				if (res.data === null) return;

				for (let i = 0; i < offset; i++) {
					this.$set(ticketsList, i, res.data[0])
				}

				for (let i = 0; i < res.data.length; i++) {
					this.$set(ticketsList, offset + i, res.data[i])
				}

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		filter(clearArray = false) {
			let item = this.tabs[this.indexTab];
			if (clearArray) item.key === 'active' ? this.active = [] : this.history = []
			const offset = (this.currentPage - 1) * 10;

			const options = {
				tab: item.key,
				limit: 10,
				offset: offset,
				date_from: !!this.off ? this.off : undefined,
				date_to: !!this.to ? this.to : undefined,
				name: !!this.search ? this.search : undefined
			};

			this.getTickets(item, options);
		},
	},
	created() {
		const headers = clientOrdersHeaders.getHeaders(this);
		this.field = headers.field;
		this.tabs = headers.tabs;
	},
	async mounted() {
		const role = this.$store.state.auth.role;

		this.tasks = (await this.$http.get(`/${role}/task`)).data.data;
		this.levels = (await this.$http.get("/settings/get-quality-levels")).data.data;
		this.works = (await this.$http.get("/settings/get-work-types")).data.data;
		this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;

		this.filter()

		// this.tabs.forEach((item) => {
		// 	this.getTickets(item, { tab: item.key });
		// });
	},
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";

.client-orders-table {
	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}

	.con-vs-tabs .con-slot-tabs {
		overflow: visible;
	}

	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}

	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.date {
			display: flex;
			align-items: center;
		}

		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}

		.vx-input-group {
			margin-right: 0;
		}

		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}

		.search .vs-con-input-label {
			width: 270px;
		}
	}

	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.add-affair_admin {
		margin-right: 25px;
	}

	.author-header {
		display: flex;
		justify-content: center;
	}

	.deal-today {
		background-color: #FBE3C5;
	}

	.vx-card__body {
		overflow-x: hidden;
	}
}
</style>
